import request from '@/utils/request'

//用户信息
export function payAccountcheck(data) {
    return request({
        url: '/api/pay/accountcheck',
        method: 'get',
        // 点击刷新不加载
        headers:{
            showLoading:false  

        },
        data
    })
}
//立即升级列表数据
export function alipayBuytypes(data) {
    return request({
        url: '/api/pay/buytypes',
        method: 'get',
        data
    })
}

//支付
export function alipayPay(data) {
    return request({
        url: '/api/pay/pay',
        method: 'post',
        params:data
    })
}

//支付确认
export function paycheck(data) {
    return request({
        url: '/api/pay/paycheck',
        method: 'get',
        data
    })
}

// 优惠券
export function apiGetCoupons(data) {
    return request({
        url: 'api/pay/getCoupons',
        method: 'post',
        // 点击刷新不加载
        quiet: true,
        headers:{
            showLoading:false  
        },
        data
    })
}